import { render, staticRenderFns } from "./TheModalAutorizacionInternacion.vue?vue&type=template&id=cc54181e&scoped=true&"
import script from "./TheModalAutorizacionInternacion.vue?vue&type=script&lang=js&"
export * from "./TheModalAutorizacionInternacion.vue?vue&type=script&lang=js&"
import style0 from "./TheModalAutorizacionInternacion.vue?vue&type=style&index=0&id=cc54181e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc54181e",
  null
  
)

export default component.exports